import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import {Attachment, EmailAddress, ReadedEmlJson} from 'eml-parse-js/dist/interface';
import moment from 'moment/moment';
import {base64ToBlob, humanFileSize, openBlob} from '@/util';
import Loading from '@/components/Loading.vue';
import {ref, watch} from 'vue';
import {getData} from '@/api/module/dms';
import {readEml} from 'eml-parse-js';
import {useStorage} from '@/composables/storage';
import useDetailContactHistoryEmailStore from '@/store/detailContactHistoryEmail';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactHistoryEmail',
  setup(__props) {


const emailStore = useDetailContactHistoryEmailStore();

useStorage(
    emailStore,
    undefined,
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        KontaktNr: parseInt(Array.isArray(route.params.contact_history_id) ? route.params.contact_history_id[0] : route.params.contact_history_id),
        Id: parseInt(Array.isArray(route.params.email_id) ? route.params.email_id[0] : route.params.email_id),
      };
    },
);

const isLoading = ref(true);
const tab = ref<'content' | 'attachments' | 'recipients'>('content');
const attachments = ref<Attachment[]>([]);

const content = ref<string | undefined>(undefined);
const emlData = ref<ReadedEmlJson | undefined>(undefined);

async function downloadEml() {
  const data: Blob = await getData(emailStore.data[0].Datei.DownloadToken);
  try {
    readEml(await data.text(), (err, data) => {
      if (err) {
        throw new Error('email ging schief');
      }

      emlData.value = data;
      if (data?.html) {
        content.value = data?.html;
      } else {
        content.value = data?.text;
      }

      attachments.value = data?.attachments ?? [];
    });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

function recipients(input: EmailAddress | EmailAddress[] | null | undefined): EmailAddress[] {
  if (!input) return [] as EmailAddress[];

  return Array.isArray(input) ? input : [input];
}

function getDisplayNameFromEmailAddress(input: EmailAddress): string {
  return input.name != '' ? `${input.name} (${input.email})` : input.email;
}

async function openAttachment(attachment: Attachment) {
  const blob = base64ToBlob(attachment.data64, attachment.contentType);
  await openBlob(blob, attachment.name);
}

watch(() => emailStore.loading, (loaded) => {
  if (!loaded) {
    downloadEml();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_window = _resolveComponent("v-window")!

  return (!isLoading.value && emlData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
          "align-tabs": "center",
          "bg-color": "primary",
          "fixed-tabs": "",
          class: "position-sticky",
          style: {"top":"3rem","z-index":"2"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, { value: "content" }, {
              default: _withCtx(() => [
                _createTextVNode("Inhalt")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "recipients" }, {
              default: _withCtx(() => [
                _createTextVNode("Empfänger")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: "attachments",
              disabled: attachments.value.length == 0
            }, {
              default: _withCtx(() => [
                _createTextVNode("Anhänge (" + _toDisplayString(attachments.value.length) + ")", 1)
              ], undefined, true),
              _: 1
            }, 8, ["disabled"])
          ], undefined, true),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_window, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, {
              value: "content",
              class: "pa-n2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { elevation: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(emlData.value.subject), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode("An: " + _toDisplayString(getDisplayNameFromEmailAddress(emlData.value.to as EmailAddress)), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Datum: " + _toDisplayString(_unref(moment)(emlData.value.date).format('DD.MM.YYYY HH:mm')), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", { innerHTML: content.value }, null, 8, _hoisted_2)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "recipients" }, {
              default: _withCtx(() => [
                (emlData.value)
                  ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipients(emlData.value.to), (recipient) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: recipient.email
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(recipient.email), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024),
                              (recipient.name != '')
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(recipient.name), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipients(emlData.value.cc), (recipient) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: recipient.email
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_badge, {
                                content: "CC",
                                color: "info",
                                inline: ""
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(recipient.email), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024),
                              (recipient.name != '')
                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(recipient.name), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "attachments" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { lines: "two" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (attachment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: attachment.id
                      }, [
                        _createVNode(_component_v_list_item, {
                          onClick: ($event: any) => (openAttachment(attachment))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(attachment.name), 1)
                              ], undefined, true),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(humanFileSize)(attachment.data.length)), 1)
                              ], undefined, true),
                              _: 2
                            }, 1024)
                          ], undefined, true),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_v_divider)
                      ]))
                    }), 128))
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : (_openBlock(), _createBlock(Loading, { key: 1 }))
}
}

})